/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const WarningForMissingNewlineEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('WARNING_FOR_MISSING_NEWLINE_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class WarningForMissingNewlineEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return WarningForMissingNewlineEnabledSettingParser.decode(input).map(res => new WarningForMissingNewlineEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return WarningForMissingNewlineEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return WarningForMissingNewlineEnabledSettingParser.encode(data);
    }
    static schema() {
        return WarningForMissingNewlineEnabledSettingParser.schema();
    }
}
